<template>
  <div id="app">
    <localization></localization>
    <drawers></drawers>
    <modals></modals>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Localization from '@/localization'
import Modals from '@/components/reno/modals/Modals'
import Drawers from '@/components/reno/drawers/Drawers'

export default {
  name: 'app',
  components: { Localization, Drawers, Modals },
  computed: {
    ...mapState(['settings']),
    ...mapState('user', ['authorized']),
    nextRoute() {
      return this.$route.query.redirect || '/'
    },
    currentRoute() {
      return this.$route.path
    },
  },
  created() {
    this.$store.dispatch('admin/init')
  },
  mounted() {
    this.$store.commit('SET_PRIMARY_COLOR', {
      color: this.settings.primaryColor,
    })
    this.$store.commit('SET_THEME', { theme: this.settings.theme })
  },
  watch: {
    '$store.state.settings.theme'(theme) {
      this.$store.commit('SET_THEME', { theme })
    },
    '$store.state.user.authorized'(authorized) {
      if (authorized && this.currentRoute === '/auth/login') {
        this.$router.replace(this.nextRoute)
      }
    },
    $route(to, from) {
      const query = Object.assign({}, to.query)
      this.$store.commit('SETUP_URL_SETTINGS', query)
    },
  },
}
</script>
